import { Alert } from "@ternary/ui"

/**
 * The notice above a settings page for an account that can view it but not change it. It is part
 * of the page from its first paint, not news, so it is no live region.
 */
export function ViewOnlyNotice() {
  return (
    <Alert role="none" tone="info">
      View only. Ask an owner to change these settings.
    </Alert>
  )
}
